const pageNameKey = "machinesCancelRequestDisconnectSupportModal";

export const machinesCancelRequestDisconnectSupportModalEn = {
  [pageNameKey]: {
    title: "Remote Access Already Active",
    message:
      "A remote access session is already active for this gateway. To start a new remote access request, the current session must be closed first.",
    confirmButton: "Disconnect",
    cancelButton: "Cancel",
  },
};

export const machinesCancelRequestDisconnectSupportModalPtBr = {
  [pageNameKey]: {
    title: "Acesso remoto já está ativo",
    message:
      "Já existe uma sessão de acesso remoto ativa para este gateway. Para iniciar uma nova solicitação de acesso remoto, a sessão atual deve ser encerrada primeiro.",
    confirmButton: "Desconectar",
    cancelButton: "Cancelar",
  },
};

export const machinesCancelRequestDisconnectSupportModalDe = {
  [pageNameKey]: {
    title: "Fernzugriff bereits aktiv",
    message:
      "Sie haben bereits eine aktive Verbindung für dieses Gateway. Um eine Anfrage für einen neuen Fernzugriff zu starten, muss die aktuelle Sitzung zuerst geschlossen werden.",
    confirmButton: "Trennen",
    cancelButton: "Stornieren",
  },
};

export const machinesCancelRequestDisconnectSupportModalZhHans = {
  [pageNameKey]: {
    title: "远程访问已激活",
    message:
      "您目前已与连接到此网关的计算机建立了远程访问会话。要发起新的远程访问请求，必须先关闭当前会话。",
    confirmButton: "断开",
    cancelButton: "取消",
  },
};

export const machinesCancelRequestDisconnectSupportModalIt = {
  [pageNameKey]: {
    title: "Accesso remoto già attivo",
    message:
      "Una sessione di accesso remoto è già attiva per questo gateway. Per avviare una nuova richiesta di accesso remoto, chiudi prima la sessione corrente.",
    confirmButton: "Disconnetti",
    cancelButton: "Annulla",
  },
};

export const machinesCancelRequestDisconnectSupportModalEs = {
  [pageNameKey]: {
    title: "El acceso remoto ya está activo",
    message:
      "Ya hay una sesión de acceso remoto activa para esta gateway. Para iniciar una nueva solicitud de acceso remoto, primero se debe cerrar la sesión actual.",
    confirmButton: "Desconectar",
    cancelButton: "Cancelar",
  },
};

export const machinesCancelRequestDisconnectSupportModalNl = {
  [pageNameKey]: {
    cancelButton: "Annuleren",
    confirmButton: "Verbinding verbreken",
    message:
      "U heeft al een actieve verbinding voor deze gateway. Om een nieuw verzoek voor externe toegang te starten, moet de huidige sessie eerst worden gesloten.",
    title: "Externe toegang al actief",
  },
};

export const machinesCancelRequestDisconnectSupportModalTr = {
  [pageNameKey]: {
    cancelButton: "İptal etmek",
    confirmButton: "Bağlantıyı kes",
    message:
      "Bu ağ geçidi için bir uzaktan erişim oturumu zaten etkin. Yeni bir uzaktan erişim isteği başlatmak için öncelikle mevcut oturumun kapatılması gerekir.",
    title: "Uzaktan Erişim Zaten Etkin",
  },
};
